import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';

/**
 * Pretendard 동적 서브셋
 * - 기존: 단일 2MB woff2 파일 (next/font/local)
 * - 변경: unicode-range 기반 동적 서브셋 (~수십KB/페이지)
 *
 * pretendard.style을 그대로 사용하는 곳과 호환을 유지하기 위해
 * 동일한 인터페이스를 export
 */
export const pretendard = {
  style: {
    fontFamily: "'Pretendard Variable', Pretendard, sans-serif",
  },
};
